<template>
	<div class="wrap">
		<div class="navbar">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>党务工作</el-breadcrumb-item>
				<el-breadcrumb-item>党员管理</el-breadcrumb-item>
				<el-breadcrumb-item>{{$route.name}}</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="datawrap">
			<div class="treeWrap" v-if="$store.state.user.userinfo.flag!=3">
				<tree @treeSelect="treeSelect"></tree>
			</div>
			<div class="datatable">
				<div class="datas">
					<div class="selectbar">
						<div>
							<el-select
								clearable
								size="small"
							 	style="margin-right: 10px;width: 120px !important;" 
								v-model="getdata.zhiwu" placeholder="请选择身份"
								@change="getdata.page = 1;totalPage = 0;dataList();">
								<el-option
									:key="index"
									v-for="(item,index) in zhiwulist"
									:label="item.level"
									:value="item.zhiwu">
								</el-option>
							</el-select>
						</div>
						<div>
							<el-button type="primary" size="small" @click="daochu">导出表格</el-button>
						</div>
					</div>
					<div class="selectdata">
						<myTables 
							:tableData="tableData"
							delkey="id"
							:tableHeader="tableHeader"
							:loading="true" 
							:indexs="false"
							:selection="false">
						</myTables>
						<Page :totalPage="totalPage" :pageSize="10" @changedata="changedata"></Page>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import tree from '@/components/tree.vue'
	import { dygl,dwgl } from '@/axios'
	import Page from '@/components/page.vue'
	import { Message } from 'element-ui'
	import myTables from '@/components/tables/tables.vue'
	export default{
		data(){
			return{
				getdata:{
					id: this.$store.state.user.userinfo.id,
					flag: this.$store.state.user.userinfo.flag,
					zhiwu:""
				},
				type:1,//1：新增 2：批量新增
				tableData:[],
				totalPage:0,
				zhiwulist:dygl.dyclass(),//身份筛选列表
				tableHeader: [     // 表头
					{prop: 'u_name', label: '姓名',width:'100'},
					{prop: 'u_zhiwu', label: '党内职务',width:'100',formatData:function(val){
						switch(val){
							case 1:
								return '书记';break;
							case 2:
								return '副书记';break;
							case 3:
								return '委员';break;
							default:
								return '暂无数据';break;
						}
					}},
					{prop: 'cy_zz', label: '所属组织'},
					{prop: 'u_phone', label: '联系方式',width:'150'},
					// 此处为操作栏，不需要可以删除，clickFun绑定此操作按钮的事件
					{
						prop: 'oper', label: '操作', fixed: 'right', width: '114',align:'center',
						oper: [
							{name: '详情', style: {color:'#bb0000'}, clickFun: this.detail,show:true,limit:''},
						]
					}
				]
			}
		},
		components:{tree,Page,myTables},
		methods:{
			// 关闭新增或编辑弹窗
			closeWin(){
				this.dialogVisible = false;
			},
			// 数据
			dataList(){
				var that = this;
				dygl.leaderList(that.getdata).then(res => {
					if(res.data.pagedata.length>0){
						that.tableData = res.data.pagedata;
						that.totalPage = res.data.count;
					}else{
						that.tableData = [];
						that.totalPage = 0;
					}
				})
			},
			// 分页查询
			changedata(current){
				var that = this;
				that.getdata.page = current;
				that.dataList();
			},
			// 树形结构筛选
			treeSelect(data){
				var that = this;
				that.getdata.id = data.id;
				that.getdata.flag = data.flag;
				that.getdata.page = 1;
				that.dataList();
			},
			// 编辑
			detail(data){
				var that = this;
				that.$router.push({
					path:'/dyxx_detail',
					query:{
						id:data.id
					}
				})
			},
			// 导出表格
			daochu(){
				var that = this;
				if(that.tableData.length == 0){
					Message({
						type:"warning",
						message:"暂无可导出的数据"
					})
				}else{
					dwgl.exportPartyOrgan(that.getdata);
				}
			}
		},
		mounted() {
			var that = this;
			that.$emit('selectTop',4)
			that.dataList();
		},
		created() {
			var that = this;
			that.$emit('selectTop',4)
		}
	}
</script>

<style lang="scss">
	.wrap{
		position: relative;
		height: 100%;
		width: 100%;
		.fengmian {
		    height: 86px;
		    width: 138px;
		    margin: 10px 16px 10px 14px;
		}
	}
</style>

